<template>
    <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-card body-style="padding: 30px">
                <img class="img" src="../../../assets/img/cp/4g1.jpg" alt="">
                <div class="introduce">
                    <p class="inner_title">4G模块</p>
                    <p class="s-detail">
                        4G LTE 是TD-LTE和FDD-LTE等LTE网络制式的统称。
                        具有通信速度快、网络频谱宽、通信灵活等特点。
                        4G模块是指硬件加载到指定频段，软件支持标准的LTE协议，
                        软硬件高度集成模组化的一种产品的统称。
                        <a href="#">[详情]</a>

                    </p>
                    <p class="end_title">钧飞智能科技有限公司出品</p>
                </div>
            </el-card>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-card body-style="padding: 30px">
                <img class="img" src="../../../assets/img/cp/4g2.png" alt="">
                <div class="introduce">
                    <p class="inner_title">4G模块</p>
                    <p class="s-detail">
                        4G除了提供高速数据接入以外,还提供语音(PCM)、短信、
                        通讯簿等功能，可以广泛用于笔记本、平板、触摸屏通信装置、
                        智能手机、视频监控、多媒体手机和车载设备等终端产品以及垂直应用。
                        <a href="#">[详情]</a>
                    </p>
                    <p class="end_title">钧飞智能科技有限公司出品</p>
                </div>
            </el-card>

        </el-col>
    </el-row>
</template>

<script>
  export default {}
</script>

<style src="../../../assets/css/smartModule.css" scoped>
    /*@import "../../assets/css/smartModule.css";*/
</style>
